const ContactUsReferences = {
  PUBLIC: 'WEB-PUBLIC',
  ONLINE: 'WEB-ONLINE',
  GROUP: 'WEB-GROUP',
};

export default ContactUsReferences;
